// Shared legend definition for the School Year Calendar (staff + portals).
// `color` is a Tailwind bg-* class. Labels can be overridden per-school via
// calendar.legend_labels[value].

export const DEFAULT_LEGEND = [
  { value: "no_school", label: "No School / Holiday", color: "bg-pink-300" },
  { value: "early_release", label: "Early Release", color: "bg-yellow-400" },
  { value: "teacher_inservice", label: "Teacher In-Service", color: "bg-blue-300" },
  { value: "conference", label: "Parent/Teacher Conference", color: "bg-purple-300" },
  { value: "vacation", label: "School Break/Vacation", color: "bg-orange-300" },
  { value: "event", label: "First & Last Day of School", color: "bg-green-300" },
];

// Hex equivalents of each legend type's Tailwind color — used for print output
// (where Tailwind classes aren't available). Keep in sync with DEFAULT_LEGEND.
export const LEGEND_HEX = {
  no_school: "#f9a8d4",     // pink-300
  early_release: "#facc15", // yellow-400
  teacher_inservice: "#93c5fd", // blue-300
  conference: "#d8b4fe",    // purple-300
  vacation: "#fdba74",      // orange-300
  event: "#86efac",         // green-300 (also first/last day)
};

/** Label for a legend type, honoring per-school overrides. */
export function legendLabel(calendar, value, fallback) {
  const override = (calendar?.legend_labels || {})[value];
  if (override && override.trim()) return override;
  const def = DEFAULT_LEGEND.find((t) => t.value === value);
  return def?.label || fallback || value;
}

/** Full legend list with per-school label overrides applied. */
export function resolveLegend(calendar) {
  return DEFAULT_LEGEND.map((t) => ({ ...t, label: legendLabel(calendar, t.value, t.label) }));
}
